<template>
  <ol :class="{'bold':bold}">
    <li v-for="(item, index) in lista" :key="index">
      <p v-html="item"></p>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    lista: {
      type: Array,
      required: true
    },
    bold:{
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.bold{
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// ui-numlist.vue?68cf61cf